var path = '/javascript/common/directives/cartCallout.html';
var html = "<div class=\"carterrorbox\">\n    <img src=\"/images/warning-sign.png\" class=\"warningpic\" />\n    <p class=\"errortext\">{{errorMessage}}</p>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;